export interface IInsertResult {
	newValue: string
	/** New cursor position after insertion */
	newCursorPos: number
}

/**
 * Insert text at the current cursor position in a textarea
 * @returns New value and cursor position
 */
export function insertAtCursor(
	textarea: HTMLTextAreaElement,
	textToInsert: string
): IInsertResult {
	const start = textarea.selectionStart || 0
	const end = textarea.selectionEnd || 0
	const value = textarea.value

	const before = value.substring(0, start)
	const after = value.substring(end)

	const newValue = before + textToInsert + after
	const newCursorPos = start + textToInsert.length

	return { newValue, newCursorPos }
}

export function setCursorPosition(
	textarea: HTMLTextAreaElement,
	position: number
): void {
	setTimeout(() => {
		textarea.focus()
		textarea.setSelectionRange(position, position)
	}, 10)
}
